// src/components/features/analysis/ComponentModal.jsx
import React from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalBody,
  ListItem
} from '../../../styles/AnalysisStyles';

const ComponentModal = ({ 
  selectedComponent, 
  analysisData, 
  onClose 
}) => {
  if (!selectedComponent) return null;

  let content = [];
  let title = '';

  switch (selectedComponent) {
    case 'permissions':
      title = 'Permissions';
      content = analysisData?.permissions?.map((perm, index) => (
        <ListItem key={index} suspicious={perm.suspicious}>
          {perm.permission}
        </ListItem>
      ));
      break;
    case 'services':
      title = 'Services';
      content = analysisData?.services?.map((service, index) => (
        <ListItem key={index}>{service}</ListItem>
      ));
      break;
    case 'activities':
      title = 'Activities';
      content = analysisData?.activities?.map((activity, index) => (
        <ListItem key={index}>{activity}</ListItem>
      ));
      break;
    case 'receivers':
      title = 'Receivers';
      content = analysisData?.receivers?.map((receiver, index) => (
        <ListItem key={index}>{receiver}</ListItem>
      ));
      break;
    default:
      break;
  }

  return (
    <Modal onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        <ModalBody>{content}</ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ComponentModal;